export const eventListStyleProps = {
    background: 'background.white',
    maxHeight: {base: '400px', mobileXL: '370px'},
    overflow: 'scroll',
};

export const eventListItemStyleProps = {
    display: 'flex',
    flexDirection: {base: 'column', mobileXL: 'row'},
    alignItems: {base: 'unset', mobileXL: 'center'},
    justifyContent: 'space-between',
    padding: '16px',
    height: {base: 'unset', mobileXL: '80px'},
    _hover: {
        backgroundColor: 'background.gray',
    },
};

export const eventListItemDateContainerStyleProps = {
    margin: 0,
    paddingRight: '10px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    sx: {
        div: {
            display: 'block',
            textAlign: 'center',
            textTransform: 'uppercase',
        },
    },
};

export const eventListItemDateMonthStyleProps = {
    fontSize: '12px',
};

export const eventListItemDateDayStyleProps = {
    fontSize: '20px',
    fontWeight: 'bold',
};

export const eventListItemDetailsStyleProps = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    maxWidth: {base: 'unset', mobileXL: '75%'},
    marginBottom: {base: '16px', mobileXL: '0'},
    sx: {
        '> p': {
            fontSize: '14px',
            fontWeight: 'semibold',
        },
    },
};

export const eventListItemTitleStyleProps = {
    lineHeight: 1.5,
    padding: '0',
    textAlign: 'left',
};

export const eventListItemBottomStyleProps = {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '2px',
    fontSize: '14px',
    lineHeight: 1.3,
    padding: '0',
};

export const EventListItemButtonStyleProps = {
    fontSize: '14px',
    textDecoration: 'none',
    fontWeight: 'normal',
};
